import { createReducer } from 'typesafe-actions';
import { combineReducers } from 'redux';
import { fetchCheckoutData } from './actions';
import { SET_CHECKOUT_VALUES } from './types';

const checkoutInitialState = {
    data: {
        isError: false,
        errorMessage: null,
        data: {},
    },
    values: {},
};

const checkoutDataReducer = createReducer(checkoutInitialState.data)
    .handleAction(fetchCheckoutData.request, (state) => ({ ...state, isLoading: true }))
    .handleAction(fetchCheckoutData.success, (state, action) => {
        const realizationDate = Array.isArray(action.payload);

        return {
            ...state,
            isLoading: false,
            isError: false,
            data: realizationDate
                ? { ...state.data, realizationDates: action.payload }
                : { ...state.data, ...action.payload },
        };
    })
    .handleAction(fetchCheckoutData.failure, (state, action) => ({
        ...state,
        isLoading: false,
        isError: true,
        errorMessage: action.payload,
    }));

const checkoutValuesReducer = createReducer(
    checkoutInitialState.values,
).handleAction(SET_CHECKOUT_VALUES, (state, action) =>
    action.payload ? { ...state, ...action.payload } : {},
);

const checkoutReducer = combineReducers({
    data: checkoutDataReducer,
    values: checkoutValuesReducer,
});

export default checkoutReducer;
